<template>
  <div>
    <div class="type-title">優惠</div>
    <div class="cell-list">
      <CellItem
        class="cell-wrap"
        textLeft="滿贈優惠"
        :textRight="parseGiveAway"
        :textLight="!!(skillInfo.giveAwayList && skillInfo.giveAwayList.length)"
        @active="showBuySendDialog = true"
      />
      <CellItem
        class="cell-wrap"
        textLeft="首單優惠"
        :textRight="skillInfo.firstOrderDiscount ? (skillInfo.firstOrderDiscount + '幣') : '未設置'"
        :textLight="!!(skillInfo.firstOrderDiscount)"
        @active="showFirstOrderDialog = true"
      />
    </div>
    <el-dialog
      :visible="showBuySendDialog"
      class="dialog-set-skill-wrap"
      custom-class="dialog-clear-style dialog-set-skill"
      :append-to-body="true"
      :show-close="false"
    >
      <div class="dialog-wrap">
        <div class="dialog-title">
          <span>滿贈優惠</span>
          <fps-icon class="pointer" type="close" size="24" @click.native="showBuySendDialog = false" />
        </div>
        <div class="dialog-content">
          <div
            v-for="(rule, index) in giveAwayList"
            :key="'rule-' + index"
          >
            <fps-icon class="delete-img pointer" tpye="close" @click.native="deleteGiveAwayList(index)" />
            <el-popover
              v-model="showPopover[index*2]"
              placement="bottom"
              :visible-arrow="false"
              :width="144"
              popper-class="select-count-wrap"
            >
              <div slot="reference" class="display-count pointer">
                <div>滿<span>{{ rule.startNum }}</span></div>
                <span :class="showPopover[index*2] && 'open'" />
              </div>
              <div class="select-count">
                <div
                  v-for="i in buyMax"
                  :key="'buy' + i"
                  class="pointer"
                  @click="selectCount(index, i, 0)"
                >{{ i }}</div>
              </div>
            </el-popover>
            <div class="line"/>
            <el-popover
              v-model="showPopover[index*2 + 1]"
              placement="bottom"
              :visible-arrow="false"
              :width="144"
              popper-class="select-count-wrap"
            >
              <div slot="reference" class="display-count pointer">
                <div>贈<span>{{ rule.giftNum }}</span></div>
                <span :class="showPopover[index*2 + 1] && 'open'" />
              </div>
              <div class="select-count">
                <div
                  v-for="i in sendMax"
                  :key="'buy' + i"
                  class="pointer"
                  @click="selectCount(index, i, 1)"
                >{{ i }}</div>
              </div>
            </el-popover>
          </div>
          <div v-if="giveAwayList.length < rulesCount" class="add-rule pointer" @click="addRule">
            <fps-icon type="add" size="18" />
            <span>增添滿贈優惠</span>
          </div>
          <button class="primary-btn" @click="submitRules">
            <span>確認</span>
          </button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible="showFirstOrderDialog"
      class="dialog-set-skill-wrap"
      custom-class="dialog-clear-style dialog-set-skill"
      :append-to-body="true"
      :show-close="false"
    >
      <div class="dialog-wrap">
        <div class="dialog-title">
          <span>首單優惠</span>
          <fps-icon class="pointer" type="close" size="24" @click.native="showFirstOrderDialog = false" />
        </div>
        <div class="dialog-content">
          <div class="tip-wrap">添加首單優惠可以拓展更多新客源趕快決定你的優惠金額吧～</div>
          <div class="setting-wrap">
            <div v-if="firstOrderDiscount" class="close-first-order pointer" @click="firstOrderDiscount = 0">
              <fps-icon type="close" size="18" color="#666" />
            </div>
            <div v-if="!firstOrderDiscount" class="add-rule pointer" @click="firstOrderDiscount = 10">
              <fps-icon type="add" size="18" />
              <span>增添首單優惠</span>
            </div>
            <el-popover
              v-else
              v-model="showFirstSelect"
              placement="bottom"
              popper-class="popper-clear-style popper-first-discount"
              trigger="click"
              width="204"
            >
              <div
                v-for="(p, i) in discountList"
                :key="`price-${i}`"
                class="select-discount"
                @click="firstOrderDiscount = p; showFirstSelect = false;"
              >{{ p }}幣</div>
              <div slot="reference" class="first-discount-btn">
                <span class="text">{{ firstOrderDiscount }}幣</span>
                <div class="arrow-bottom" :class="showFirstSelect && 'arrow-top'" />
              </div>
            </el-popover>
            <button class="primary-btn" @click="submitFirstDiscount">
              <span>確認</span>
            </button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import CellItem from './cells'
export default {
  components: {
    CellItem,
  },
  props: {
    skillInfo: Object,
    gameInfo: Object,
  },
  data() {
    const rulesCount = 3
    return {
      showBuySendDialog: false,
      showFirstOrderDialog: false,
      showFirstSelect: false,
      giveAwayList: [],
      showPopover: new Array(rulesCount * 2).fill(false),
      rulesCount,
      firstOrderDiscount: 0,
      sendMax: 15,
      buyMax: 15,
    }
  },
  watch: {
    showFirstOrderDialog(value) {
      if (!value) return
      this.firstOrderDiscount = this.skillInfo.firstOrderDiscount
    },
    showBuySendDialog(value) {
      if (!value) return
      const { giveAwayList } = this.skillInfo
      if (giveAwayList && giveAwayList.length) {
        this.giveAwayList = JSON.parse(JSON.stringify(giveAwayList))
      } else {
        this.giveAwayList = []
      }
    },
  },
  computed: {
    parseGiveAway() {
      const { giveAwayList } = this.skillInfo
      if (giveAwayList && giveAwayList.length) {
        return giveAwayList.map(item => (`滿${item.startNum}贈${item.giftNum}`)).join('/')
      } else {
        return '未設置'
      }
    },
    discountList() {
      if (!this.skillInfo.price) return []
      const list = []
      let discount = 10
      while (discount < this.skillInfo.price) {
        list.push(discount)
        discount += 10
      }
      list.push(this.skillInfo.price)
      return list
    },
  },
  methods: {
    sortGiveAwayList() {
      this.giveAwayList.sort((a, b) => a.startNum - b.startNum)
    },
    addRule() {
      this.giveAwayList.unshift({ startNum: 5, giftNum: 1 })
      this.sortGiveAwayList()
    },
    submitRules() {
      if (new Set(this.giveAwayList.map(item => item.startNum)).size !== this.giveAwayList.length) {
        this.$message('您重複設定了相同的優惠，麻煩重新選擇喔～')
        return
      }
      this.$emit('setSkillInfo', {
        giveAwayList: this.giveAwayList,
      })
      this.showBuySendDialog = false
    },
    submitFirstDiscount() {
      this.$emit('setSkillInfo', {
        firstOrderDiscount: this.firstOrderDiscount,
      })
      this.showFirstOrderDialog = false
    },
    selectCount(index, num, flag) {
      this.$set(this.showPopover, index * 2 + flag, false)
      const obj = this.giveAwayList[index]
      if (flag) {
        obj.giftNum = num
      } else {
        obj.startNum = num
      }
      this.sortGiveAwayList()
    },
    deleteGiveAwayList(index) {
      this.giveAwayList.splice(index, 1)
    },
  }
}
</script>
<style lang="scss">
    .popper-first-discount {
      background: #FFFFFF;
      border-radius: 8px;
      max-height: 180px;
      overflow-y: auto;
      .select-discount {
        width: 100%;
        height: 38px;
        @include flex;
        font-weight: 500;
        font-size: 14px;
        line-height: 14px;
        color: #333333;
        cursor: pointer;
        &:hover {
          background: #f6f6f6;
        }
        &:active {
          background: #e6e6e6;
        }
      }
    }
</style>
<style lang="scss" scoped>
  .select-count-wrap {
    padding: 4px 0;
    border-radius: 8px;
    overflow: hidden;
    .select-count {
      height: 228px;
      overflow-y: auto;
      @include hideScrollBar();
      &>div {
        height: 34px;
        text-align: center;
        line-height: 34px;
        font-weight: 500;
        font-size: 16px;
        text-align: center;
        color: #333333;
        &:hover {
          background: #f6f6f6;
        }
        &:active {
          background: #e6e6e6;
        }
      }
    }
  }
  .dialog-set-skill-wrap /deep/ .dialog-set-skill {
    width: 420px;
  }
  .dialog-set-skill-wrap /deep/ .dialog-wrap {
    background: #FFFFFF;
    border-radius: 8px;
    width: 420px;
    .dialog-title {
      @include flex(space-between);
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
      color: $color-gray-1;
      border-bottom: 1px solid #E0E0E0;
      height: 64px;
      padding: 0 18px 0 30px;
    }
    .dialog-content {
      padding: 16px 30px 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      &>div {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        .delete-img {
          margin-right: 10px;
          font-size: 20px;
          border-radius: 50%;
          &:hover {
            background: #F1F2F6;
          }
        }
        .line {
          width: 8px;
          height: 2px;
          background: #999999;
          margin: 0 20px;
        }
        .display-count {
          width: 144px;
          height: 44px;
          box-sizing: border-box;
          border: 1px solid #999999;
          border-radius: 8px;
          display: flex;
          justify-content: space-between;
          padding: 0 15px;
          align-items: center;
          &>div {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #999999;

            span {
              margin-left: 10px;
              font-weight: 500;
              font-size: 24px;
              color: #333333;
            }
          }
          &>span {
            border-top: 5px solid #666666;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            transition: all .3s;
            &.open {
              transform: rotate(180deg);
            }
          }
        }
      }
      .add-rule {
        margin-bottom: 8px;
        align-self: flex-start;
        width: 145px;
        height: 44px;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333333;
        span {
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          margin-left: 5px;
        }
        &:hover {
          background: #F1F2F6;
          color: #FA006E;
        }
      }
      .primary-btn {
        margin-top: 20px;
        width: 100px;
        height: 40px;
        align-self: flex-end;
      }
      .tip-wrap {
        width: 100%;
        font-size: 12px;
        line-height: 17px;
        color: $color-gray-3;
        margin-bottom: 20px;
        justify-content: flex-start;
      }
      .setting-wrap {
        width: 100%;
        @include flex(space-between);
        .add-rule {
          margin-bottom: 0;
        }
        .primary-btn {
          margin-top: 0;
        }
        .close-first-order {
          width: 28px;
          height: 28px;
          @include flex;
          border-radius: 50%;
          &:hover {
            background: $color-button;
          }
          &:active {
            background: #e1e2e6;
          }
        }
      }
    }
  }
  .first-discount-btn {
    width: 204px;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid #999999;
    border-radius: 4px;
    cursor: pointer;
    @include flex(space-between);
    padding: 0 15px 0 12px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: $color-gray-1;
    .arrow-bottom {
      width: 0;
      height: 0;
      font-size: 0;
      border-bottom: 5px solid #666;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      transition: all .3s;
    }
    .arrow-top {
      transform: rotate(180deg);
    }
  }
  .type-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: $color-gray-1;
    margin-top: 30px;
  }
  .cell-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .cell-wrap {
      width: 435px;
      height: 62px;
      margin: 10px 0;
      &:nth-child(odd) {
        margin-right: 28px;
      }
    }
  }
</style>
